// src/pages/PurchasesPage.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PurchaseFormModal from '../components/PurchaseFormModal';
import PurchaseDetailsModal from '../components/PurchaseDetailsModal';
import { formatDate } from '../utils/formatDate';
import './PurchasesPage.css';
import { API_URL } from "../config";

function PurchasesPage() {
    const navigate = useNavigate();
    const [purchases, setPurchases] = useState([]);
    const [showFormModal, setShowFormModal] = useState(false);
    const [selectedPurchase, setSelectedPurchase] = useState(null);
    const currentUser = JSON.parse(localStorage.getItem('user'));

    useEffect(() => {
        fetchPurchases();
    }, []);

    const fetchPurchases = async () => {
        try {
            const response = await fetch(`${API_URL}/purchases`, {
                credentials: 'include',
            });
            if (!response.ok) throw new Error('Błąd pobierania zamówień.');
            const data = await response.json();
            setPurchases(data);
        } catch (error) {
            console.error('Błąd:', error);
        }
    };

    const handlePurchaseSave = (newPurchase) => {
        setPurchases([newPurchase, ...purchases]);
    };

	const handleUpdateStatus = (updatedPurchase) => {
		setPurchases(purchases.map(p => p.id === updatedPurchase.id ? updatedPurchase : p));
		setSelectedPurchase(updatedPurchase); // Aktualizujemy modal
		if (updatedPurchase.status === 'Dostarczono') {
			setSelectedPurchase(null); // Zamykamy modal, jeśli status to "Dostarczono"
		}
	};

    const handleDelete = (purchaseId) => {
        setPurchases(purchases.filter(p => p.id !== purchaseId));
        setSelectedPurchase(null);
    };

    return (
        <div className="purchases-page">
            <header className="purchases-header">
                <h2>Zamówienia</h2>
                <div className="purchases-header-buttons">
                    <button className="btn-submit" onClick={() => setShowFormModal(true)}>
                        Złóż Zamówienie
                    </button>
                    <button className="btn-submit" onClick={() => navigate('/zakupy/zrealizowane')}>
                        Zamówienia Zrealizowane
                    </button>
                    <button className="btn-submit" onClick={() => navigate('/zakupy/odrzucone')}>
                        Zamówienia Odrzucone
                    </button>
                </div>
            </header>
            <section className="purchases-grid">
                {purchases.length === 0 ? (
                    <p>Brak aktywnych zamówień.</p>
                ) : (
                    purchases.map(purchase => (
                        <div
                            key={purchase.id}
                            className="purchase-card"
                            onClick={() => setSelectedPurchase(purchase)}
                        >
                            <span className="purchase-number">#{purchase.nr_zamowienia}</span>
                            <p><strong>Nr Zlecenia:</strong> {purchase.nr_ref}</p>
                            <p><strong>Tytuł Zamówienia:</strong> {purchase.tytul_zamowienia}</p>
                            <p><strong>Osoba Zamawiająca:</strong> {purchase.first_name} {purchase.last_name}</p>
                            <p><strong>Data Zamówienia:</strong> {formatDate(purchase.data_utworzenia)}</p>
                            <p><strong>Termin Realizacji:</strong> {formatDate(purchase.termin_realizacji)}</p>
                            <p><strong>Status:</strong> {purchase.status}</p>
                        </div>
                    ))
                )}
            </section>
            {showFormModal && (
                <PurchaseFormModal
                    onClose={() => setShowFormModal(false)}
                    onSave={handlePurchaseSave}
                />
            )}
            {selectedPurchase && (
                <PurchaseDetailsModal
                    purchase={selectedPurchase}
                    onClose={() => setSelectedPurchase(null)}
                    onUpdateStatus={handleUpdateStatus}
                    onDelete={handleDelete}
                    currentUser={currentUser}
                />
            )}
        </div>
    );
}

export default PurchasesPage;